import directives from './directives';

const init = Vue => {
	Vue.directive('focus', directives.focus);
	Vue.directive('debounce', directives.debounce);
};

export default init;
